import { Box, Divider, Typography } from '@mui/material';
import { IconWrapper, IStyles, pxToRem, pxTovW } from '@geneo2-web/shared-ui';

const styles: IStyles = {
  paperDetailsBox: {
    display: 'flex',
    justifyContent: 'space-between',
    background: '#FFFFFF',
    boxShadow: `0px 0px ${pxToRem(5)} #E7E7E7D9`,
    borderRadius: { xs: pxToRem(10), md: pxTovW(15) },
    paddingX: { xs: pxToRem(10), md: pxTovW(20) },
    paddingY: { xs: pxToRem(10), md: pxTovW(25) },
  },
  detailsBox: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(5), md: pxTovW(5) },
  },
};

export const QuestionCountAndMarks = (props: {
  questionCount: number;
  totalMarks: number;
}) => {
  const { questionCount, totalMarks } = props;
  return (
    <Box sx={styles.paperDetailsBox}>
      <Box sx={styles.detailsBox}>
        <IconWrapper
          name="questions"
          size="md"
          type="png"
          parentFolder="icons"
        />
        <Typography variant="h4">
          No. of Questions:
          <b> {questionCount ?? 0}</b>
        </Typography>
      </Box>

      <Divider
        orientation="vertical"
        sx={{ width: '1px', height: '100%', backgroundColor: '#E0DFDE' }}
      />

      <Box sx={styles.detailsBox}>
        <IconWrapper
          name="percentage-primary"
          size="md"
          type="png"
          parentFolder="icons"
        />
        <Typography variant="h4">
          Total Marks:<b> {totalMarks ?? 0}</b>
        </Typography>
      </Box>
    </Box>
  );
};
